import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { DEBOUNCE_TIME_FILTERING } from '../../../constants';
import { FilterTypeEnum } from '../../../enums/filter.enum';
import * as moment from 'moment';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filters.component.html',
  styleUrls: ['./table-filters.component.scss'],  
})

export class TableFiltersComponent implements OnInit, OnDestroy {

  @Input() column: any;
  @Input() filter: any;
  @Output() filterChange = new EventEmitter<any>();

  filterType: typeof FilterTypeEnum = FilterTypeEnum;
  faFilter = faFilter;
  faClear = faTimes;

  dateRangeFocus: boolean = false;
  oldFilterJson: string;

  subject = new Subject();
  debounceSubscribtion: Subscription;

  dateRangeFormGroup: FormGroup;
  startDateFormControl = new FormControl();
  endDateFormControl = new FormControl();
  dateFormControl = new FormControl();
  textFormControl = new FormControl();
  numberFormControl = new FormControl();
  selectFormControl = new FormControl();
  multipleSelectFormControl = new FormControl();
  booleanFormControl = new FormControl();

  constructor(
    private formBuilder: FormBuilder,
  ) {
    this.debounceSubscribtion = this.subject.pipe(
      debounceTime(DEBOUNCE_TIME_FILTERING),
      map(() => this.filterChange.emit(this.filter))
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.debounceSubscribtion.unsubscribe();
  }

  ngOnInit(): void {
    this.dateRangeFormGroup = this.formBuilder.group({
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl,
    });

    if (this.column.name === 'brands' && this.column.filter.options?.length > 0) {
      const allValues = this.column.filter.options.map((option: any) => option.value);
      this.multipleSelectFormControl.setValue(allValues);
      this.filter[this.column.name] = allValues;
    }
  }
 
  onClear() {
    const column = this.column;
    switch (column.filter.type) {
      case FilterTypeEnum.Text:
        this.textFormControl.setValue('');
        break;
      case FilterTypeEnum.Number:
        this.numberFormControl.setValue('');
        break;
      case FilterTypeEnum.Date:
        this.dateFormControl.setValue('');
        break;
      case FilterTypeEnum.DateRange:
        this.endDateFormControl.setValue('');
        this.startDateFormControl.setValue('');
        break;
    }
    this.filterData();
  }

  filterData() {
    let column = this.column;

    if (column == undefined) {
      console.error("Column not found", column.name);
      return;
    }

    switch (column.filter.type) {
      case FilterTypeEnum.Text:
        this.filter[column.name] = this.textFormControl.value.trim();
        break;
      case FilterTypeEnum.Number:
        this.filter[column.name] = this.numberFormControl.value;
        break;
      case FilterTypeEnum.Select:
        this.filter[column.name] = this.selectFormControl.value;
        break;
      case FilterTypeEnum.MultipleSelect:
        this.filter[column.name] = this.multipleSelectFormControl.value;
        break;
      case FilterTypeEnum.Boolean:
        this.filter[column.name] = this.booleanFormControl.value;
        break;
      case FilterTypeEnum.Date:
        this.filter[column.name + 'StartDate'] = this.dateFormControl.value;
        this.filter[column.name + 'EndDate'] = this.dateFormControl.value ? moment(this.dateFormControl.value).clone().add(1, 'days') : null;

        break;
      case FilterTypeEnum.DateRange:
        this.filter[column.name + 'StartDate'] = this.startDateFormControl.value;
        this.filter[column.name + 'EndDate'] = this.endDateFormControl.value ? moment(this.endDateFormControl.value).clone().add(1, 'days') : null;

        if (this.startDateFormControl.value && this.endDateFormControl.value && this.startDateFormControl.value > this.endDateFormControl.value)
          return;

        if ((!this.startDateFormControl.value && this.endDateFormControl.value) || (this.startDateFormControl.value && !this.endDateFormControl.value))
          return;

        break;
      default:
        break;
    }

    let json: string = JSON.stringify(this.filter);

    if (this.oldFilterJson === json) return;

    this.oldFilterJson = json;

    if (json == '{}') {
      this.subject.next('')
    } else {
      this.subject.next(json)
    }
  }
 
}
